module.exports = "/_next/static/images/45e91749be4b992c0dd495badcbbe4d2-holding-device-smile@1x.jpg.webp";